.image-preview-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
    background-color: var(--off-white);
    border: 1px solid var(--form-border);
    border-bottom: none;
    border-radius: 8px 8px 0 0;
}

.image-preview-container:hover {
    border-color: var(--grey-lt);
}

.image-preview {
    position: relative;
    width: 96px;
    height: 96px;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--white);
    border: 1px solid var(--off-white-dk);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
    animation: scale-in 0.2s ease-out;
}

@keyframes scale-in {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.image-preview:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: var(--blue);
}

.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-type-badge {
    position: absolute;
    bottom: 4px;
    right: 4px;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    color: var(--white);
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
}

.image-preview:hover .image-type-badge {
    opacity: 1;
}

.remove-image-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    background: var(--white);
    color: var(--grey-dk);
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: all 0.2s;
    z-index: 1;
}

.remove-image-btn:hover {
    background: var(--red);
    color: var(--white);
    transform: scale(1.1);
}
